import styled from 'styled-components'

export const QuestionWrapper = styled.div`
  width: 100%;
  line-height: 150%;
  margin-top: 16px;

  && {
    .header {
      display: flex;
      justify-content: space-between;
    }

    a {
      margin-left: 24px;
      color: #1576e1;
    }

    input {
      // TODO: responsiveness
      width: 95%;
    }
  }
`

export const QuestionTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`

export const QuestionResponse = styled.div`
  color: #92979c;
  padding: 8px 0px;
`

export const QuestionCorrection = styled.div`
  width: 100%;
  padding: 8px;
  background: #e6f2ec;
  border-radius: 8px;
  color: #171a1c;
`
export const ValidateAllWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
`

export const NotesWrapper = styled.div`
  background-color: #0b97c4;
  max-height: 600px;
  overflow-y: auto;
`
